import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useAsync from '../hooks/useAsync';
import UserServices from '../services/UserServices';
import TogalButtonForStatus from './TogelButton/TogalButtonForStatus';
import VendorUpdate from './Update Model/UpdateVendor';
import ViewVendor from './View Model/ViewVendor';
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal';
import UserStatus from './TogelButton/UserStatus';
import ReactPaginate from 'react-paginate';
import { FaRegEye, FaArrowLeft } from "react-icons/fa";
import TogalButtonForBlockStatus from './TogelButton/TogalButtonForBlockStatus';
import {  useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
Modal.setAppElement('#root');


function Vendor() {
  const { data, error, isLoading, run } = useAsync(UserServices.getAllVendor);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState('');
  const [planFilter, setPlanFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState(data?.data || []);
  const navigate = useNavigate();



  const handleBack = () => {
    navigate(-1);
  };

  const handleViewDetails = (vendor) => {
    setSelectedUser(vendor);
    setIsModalOpen(true);
  };

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11) and pad with leading zero
    const year = date.getFullYear(); 
    return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const usersPerPage = 20;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const filteredUsers = (data?.data || []).filter((vendor) => {
    const Name = vendor?.name ? vendor.name.toLowerCase() : '';
    const email = vendor?.email ? vendor.email.toLowerCase() : '';
    const mobileNo = vendor?.mobileNo ? vendor.mobileNo.toString() : '';
    const matchesUserType = userTypeFilter
      ? vendor.employeeType && vendor.employeeType.toLowerCase() === userTypeFilter.toLowerCase()
      : true;
    const matchesPlan = planFilter ? vendor.plan === planFilter : true;

    return (
      (Name.includes(searchQuery.toLowerCase().trim()) ||
        email.includes(searchQuery.toLowerCase()) ||
        mobileNo.includes(searchQuery)) &&
      matchesUserType &&
      matchesPlan
    );
  });

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const generateExcel = () => {
    const filteredData = filteredUsers?.map((vendor) => ({
      userType: vendor?.employeeType,
      name: vendor?.name,
      pancard: process.env.REACT_APP_URL + vendor?.idImage,
      drivinglicence: process.env.REACT_APP_URL + vendor?.document,
      email: vendor?.email,
      address: vendor?.address,
      city: vendor?.city,
      state: vendor?.state,
      mobileNo: vendor?.mobileNo,
      date: formatDateTime(vendor?.createdAt),
      status: vendor?.status
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'vendor');
    XLSX.writeFile(wb, 'vendor_data.xlsx');
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const handleUserTypeChange = (e) => {
    setUserTypeFilter(e.target.value);
  };
  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handleViewCities = (id) => {
    if (id) {
      window.location.href = `/Vendoroderview?id=${id}`;
    }
  };
  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">Owner Registration List    <span className="badge bg-warning" /></h5>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Owner List
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center">
          <div className="pe-1 mb-xl-0">
            <Link className="round-add-btn" to="/add-vendor">
              <img src="img/plus.svg" alt="Add Shop" />
            </Link>
            {/* <div className="sub-title-box-right d-flex" style={{ gap: 20 }}>
              <button className="excel-btn" onClick={generateExcel}>
                <img src="img/excel.svg" alt="Download Excel" />
                Download
              </button>
            </div> */}
          </div>
           <button
            onClick={handleBack}
            className="btn btn-sm btn-outline-secondary d-flex align-items-center me-3"
            style={{ cursor: 'pointer' }}
          >
            <FaArrowLeft className="me-1" /> Back
          </button>
        </div>
      </div>
      <div className="container-box px-0 user-manager">
        <div className="Tablesearch_design">
          <div className="row">
            <div className='col-md-6'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <input
                  type="search"
                  name="search"
                  placeholder="Search by Name, Mobile and Email id"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className='form-control'
                />
                <button className="search-btn">Search</button>
              </div>
            </div>
          </div>
        </div>
        <div className="container-box-inner table-reponsive-tabe">
          <div className='table-responsive'>
            <table id="example" className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  {/* <th>USER TYPE</th> */}
                  <th>IMAGE</th>
                  <th>NAME</th>
                  <th>MOBILE NO.</th>
                  {/* <th>SubCategory</th> */}
                  <th>EMAIL</th>
                  <th>CITY</th>
                  <th>ADDRESS</th>
                  {/* <th>ODER VIEW</th> */}
                  <th>REGISTRATION DATE</th>
                  <th>STATUS</th>
                  <th>Block</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers?.map((vendor, index) => (
                  <tr key={vendor?.id || index}> {/* Ensure a unique key for each row */}
                    <td>{index + 1 + indexOfFirstUser}</td>
                    {/* <td><span class="usertype">{vendor?.employeeType || "N/A"} </span></td> */}
                    <td>
                      <img src={vendor?.image ? `${process.env.REACT_APP_URL}${vendor?.image}` : 'img/profile-img.png'} alt="" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
                    </td>
                    <td>{vendor?.name || "N/A"}</td>
                    <td>{vendor?.mobileNo || "N/A"}</td>
                    {/* <td>{vendor?.shopData?.subCategory || "N/A"}</td> */}

                    <td>{vendor?.email || "N/A"}</td>
                    <td>{vendor?.cityName || "N/A"}</td>
                    <td>{vendor?.address || "N/A"}</td>
                    {/* <td
                    onClick={() => handleViewCities(vendor._id)}
                    className="view-cities-button"
                    data-tooltip-id="view-cities-tooltip"
                    data-tooltip-content="Order View"
                  >
                    <FaRegEye className="custom-icon" />
                    <Tooltip id="view-cities-tooltip" />
                  </td> */}
                    <td>{vendor?.createdAt ? formatDate(vendor.createdAt) : "N/A"}</td>

                    {vendor?.status && vendor.status !== "Block" ? (
                      <td className="status-toggle">
                        <TogalButtonForStatus data={vendor} page="vendor" onSuccess={() => run()} />
                      </td>
                    ) : (
                      <td>N/A</td>
                    )}
                    <td className="status-toggle">
                      <TogalButtonForBlockStatus data={vendor} page="vendor" onSuccess={() => run()} />
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === index && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(vendor)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(vendor)}>Delete</button>
                              </li>
                              <li>
                                <button className="approve" style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(vendor)}>View</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredUsers?.length || 0) / usersPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewVendor vendor={selectedUser} closeModal={closeModal} />
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <VendorUpdate vendor={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton data={selectedEdit} page="Vendor" closeModal={closeDeleteModal} onSuccess={run} />
      </Modal>


    </div>
  );
}

export default Vendor;
